import { SchoolByGroup, SearchSchoolResponse } from 'login-data-access';

export function groupSchools(
  schools: SearchSchoolResponse[],
): SchoolByGroup[] {
  const groups: SchoolByGroup[] = [];

  for (const school of schools) {
    const existing = groups.find((group) => group.GRUPO === school.DESCRICAO_GRUPO);
    if (existing) {
      existing.ESCOLAS.push(school);
    } else {
      groups.push({ GRUPO: school.DESCRICAO_GRUPO, ESCOLAS: [school] });
    }
  }

  return groups;
}

export function filterSchools(
  schools: SearchSchoolResponse[],
  filterBy: string,
): SearchSchoolResponse[] {
  const filterLower = filterBy.toLocaleLowerCase();

  return schools.filter(
    (escola) =>
      escola.DESCRICAO_GRUPO.toLocaleLowerCase().indexOf(filterLower) > -1 ||
      escola.ESCOLA.toLocaleLowerCase().indexOf(filterLower) > -1 ||
      `${escola.CDESCOLA}`.toLocaleLowerCase().indexOf(filterLower) > -1,
  );
}
